import Dexie from 'dexie';

const db: any = new Dexie('queryResults');

const createDb = () => {
    db.version(2).stores({
        orderRequests: '++id,type,request,insert_date',
        returnRequests: '++id,request,insert_date',
        requests: '++id, url, response, insert_date',
        images: '++id, url, base64_url, insert_date',
        tour: '++id,isActive,insert_date',
    });
    db.version(3).stores({
        orderRequests: '++id,type,request,insert_date',
        returnRequests: '++id,request,insert_date',
        requests: '++id, url, response, insert_date',
        images: '++id, url, base64_url, insert_date',
        tour: '++id,isActive,insert_date',
        aiGenerationTour: '++id,isActive,insert_date',
    });
    db.open().catch(function (err: any) {
        console.error(err.stack || err);
    });
};
createDb();

const getAllItemFromDb = async (tableName: string) => {
    const items = await db[tableName].orderBy('insert_date').toArray();
    return items;
};

const getItemFromDb = async (tableName: string, request: string) => {
    const items = await db[tableName].where('request').equals(request).toArray();
    return items;
};

const getImageFromDb = async (url: string) => {
    const items = await db.images.where('url').equals(url).toArray();
    return items;
};

const addItemToDb = async (tableName: string, request: any, type?: any) => {
    if (type) {
        await db[tableName]
            .add({
                request,
                type,
                insert_date: Date.now(),
            })
            .catch((e: any) => {
                if (e.name === 'QuotaExceededError' || (e.inner && e.inner.name === 'QuotaExceededError')) {
                    // QuotaExceededError may occur as the inner error of an AbortError
                    console.error('QuotaExceeded error!');
                } else {
                    // Any other error
                    console.error(e);
                }
            });
    } else {
        await db[tableName]
            .add({
                request,
                insert_date: Date.now(),
            })
            .catch((e: any) => {
                if (e.name === 'QuotaExceededError' || (e.inner && e.inner.name === 'QuotaExceededError')) {
                    // QuotaExceededError may occur as the inner error of an AbortError
                    console.error('QuotaExceeded error!');
                } else {
                    // Any other error
                    console.error(e);
                }
            });
    }
};

const addImageToDb = async (url: string, base64_url: string) => {
    await db.images
        .add({
            url,
            base64_url,
            insert_date: Date.now(),
        })
        .catch((e: any) => {
            if (e.name === 'QuotaExceededError' || (e.inner && e.inner.name === 'QuotaExceededError')) {
                // QuotaExceededError may occur as the inner error of an AbortError
                console.error('QuotaExceeded error!');
            } else {
                // Any other error
                console.error(e);
            }
        });
};

const deleteItemFromDb = async (tableName: string, id: number) => {
    await db[tableName].where('id').equals(id).delete();
};

const deleteDb = () => {
    db.delete();
};

const updateOrAddItemInDb = async <T>(tableName: string, id: number, updates: Partial<T> & { id?: number }) => {
    const item = await db.table(tableName).get(id);

    if (item) {
        await db.table(tableName).update(id, updates);
    } else {
        await db.table(tableName).add({ ...updates, id });
    }
};
const getItemInDb = async <T>(tableName: string, id: number): Promise<T | null> => {
    const item = await db.table(tableName).get(id);
    return item || null;
};
const IndexedDbWrapper = {
    createDb,
    getItemFromDb,
    getAllItemFromDb,
    getImageFromDb,
    addItemToDb,
    addImageToDb,
    deleteItemFromDb,
    deleteDb,
    updateOrAddItemInDb,
    getItemInDb,
};

export default IndexedDbWrapper;
